export default {
    name: 'q-tooltip',
    props: {
        position: {
            type: String,
            default: 'bottom',
        },
        color: {
            type: String,
            default: 'inkwell-30',
        },
        noWrap: {
            type: Boolean,
            default: true,
        },
        relative: {
            type: Boolean,
            default: false,
        },
    },
}
